import { render, staticRenderFns } from "./CompanyPageOverview.vue?vue&type=template&id=9d675cd4&scoped=true"
import script from "./CompanyPageOverview.vue?vue&type=script&lang=js"
export * from "./CompanyPageOverview.vue?vue&type=script&lang=js"
import style0 from "./CompanyPageOverview.vue?vue&type=style&index=0&id=9d675cd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d675cd4",
  null
  
)

export default component.exports